import { SHERLOCK } from '@/utils/service-providers';
import * as t from './endpoints';
import {
  ConsultantAnalysisFilters,
  FiduciaryAnalysis,
  FiduciaryAnalysisFilters,
  FundAnalysis,
  FundAnalysisParams,
  OrganisationAnalysis,
  Paginated,
  PaginatedV2,
  ProviderAnalysisFilters,
  SchemeAnalysis,
  SchemeAnalysisFilters,
  SubFundAnalysisFilters,
  SubfundAnalysis,
  SubmissionSummary
} from './types';
import { HTTPServiceClient } from '@/packages/http/service';
/**
 * --------------------------------------------------
 * Analysis HTTP Serice
 * --------------------------------------------------
 **/
export const AnalysisService = {
  GET_FUND_ANALYSIS_V2: async (
    params?: FundAnalysisParams
  ): Promise<Paginated<FundAnalysis>> => {
    const clientId = params?.filters?.clientId;
    const fundAnalysisApi = `${SHERLOCK}/client/${clientId}/funds/analysis?`;
    const urlString = t.getFundAnalysisUrl(params);
    const { data } = await HTTPServiceClient.get<Paginated<FundAnalysis>>(
      fundAnalysisApi + urlString
    );
    return data;
  },

  GET_SUBMISSION_SUMMARY: async (params: {
    clientId: string;
    submissionId: string;
  }): Promise<SubmissionSummary> => {
    const summaryApi = `${SHERLOCK}/client/${params.clientId}/submissions/${params.submissionId}/summary`;
    const { data } = await HTTPServiceClient.get<SubmissionSummary>(summaryApi);
    return data;
  },

  GET_SCHEME_ANALYSIS: async (
    params?: SchemeAnalysisFilters
  ): Promise<PaginatedV2<SchemeAnalysis>> => {
    const schemeAnalysisApi = `${SHERLOCK}/client/${params?.clientId}/schemes/analysis?`;
    const urlString = t.getSchemeAnalysisUrlParams(params);
    const { data } = await HTTPServiceClient.get<PaginatedV2<SchemeAnalysis>>(
      schemeAnalysisApi + urlString
    );
    return data;
  },

  GET_SUBFUND_ANALYSIS: async (
    params?: SubFundAnalysisFilters
  ): Promise<PaginatedV2<SubfundAnalysis>> => {
    const subfundAnalysisApi = `${SHERLOCK}/client/${params?.clientId}/subfunds/analysis?`;
    const urlString = t.getSubFundAnalysisUrlParams(params);
    const { data } = await HTTPServiceClient.get<PaginatedV2<SubfundAnalysis>>(
      subfundAnalysisApi + urlString
    );
    return data;
  },

  GET_CONSULTANT_ANALYSIS: async (
    params: ConsultantAnalysisFilters
  ): Promise<OrganisationAnalysis> => {
    const consultantAnalysisApi = `${SHERLOCK}/client/${params?.consultant_entity_id}/consultant/analysis?`;
    const urlString = t.getConsultantAnalysisUrlParams(params);
    const { data } = await HTTPServiceClient.get<{
      data: OrganisationAnalysis;
    }>(consultantAnalysisApi + urlString);
    return data?.data;
  },

  GET_PROVIDER_ANALYSIS: async (
    params: ProviderAnalysisFilters
  ): Promise<OrganisationAnalysis> => {
    const consultantAnalysisApi = `${SHERLOCK}/client/${params?.provider_entity_id}/provider/analysis?`;
    const urlString = t.getProviderUrlParams(params);
    const { data } = await HTTPServiceClient.get<{
      data: OrganisationAnalysis;
    }>(consultantAnalysisApi + urlString);
    return data?.data;
  },

  GET_FIDUCIARY_ANALYSIS: async (
    params: FiduciaryAnalysisFilters
  ): Promise<PaginatedV2<FiduciaryAnalysis>> => {
    const consultantAnalysisApi = `${SHERLOCK}/client/${params?.entity_id}/fiduciary/analysis?`;
    const urlString = t.getFiduciaryAnalysisUrlParams(params);
    const { data } = await HTTPServiceClient.get<
      PaginatedV2<FiduciaryAnalysis>
    >(consultantAnalysisApi + urlString);
    return data;
  }
};
